module.exports = __webpack_public_path__ + "static/media/upload-scanned-material.ddaa455d.png";